"use client";

import { usePrefetchOnTouch } from "@faire/retailer-visitor-shared/hooks/pdpPrefetching/usePDPPrefetchOnTouch";
import { generateProductUrlForBrandPage } from "@faire/retailer-visitor-shared/views/brand/utils/generateProductUrlForBrandPage";
import { usePreloadNavigationToPDP } from "@faire/retailer-visitor-shared/views/product/preload/preloadNavigationToPDP";
import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { useOnProductClickBase } from "../../productTileActions/useOnProductClickBase";

import { ProductLinkProps } from "./Brand/ProductLinkForBrandPageProps";

export const ProductLinkForProductOnlyTile = ({
  data,
  children,
}: {
  data: ProductLinkProps;
  children: ReactNode;
}) => {
  const productUrl = generateProductUrlForBrandPage(
    data.token ?? "",
    data.selectedProductOptionToken
  );

  const { onTouchStart } = usePrefetchOnTouch(
    {
      productToken: data.token,
      bestImage: data.bestImage,
      images: data.images ?? [],
      brandToken: data.brandToken,
    },
    productUrl
  );

  const onProductClick = useOnProductClickBase({
    token: data.token,
    bestImage: data.bestImage,
    images: data.images,
    impressionId: data.impressionId,
    promotedBy: data.promotedBy,
    showVerticalImagery: data.showVerticalImagery,
  });
  const preloadNavigationToPDP = usePreloadNavigationToPDP();

  const prefetchPDPData = () => {
    preloadNavigationToPDP(
      {
        productToken: data.token,
        brandToken: data.brandToken,
        bestImage: data.bestImage,
        images: data.images ?? [],
        showVerticalImagery: data.showVerticalImagery,
      },
      productUrl
    );
  };

  return (
    <div tabIndex={0}>
      <ProductLink
        key={`${data.token}-product-tile`}
        onClick={onProductClick}
        onMouseDown={prefetchPDPData}
        onTouchStart={onTouchStart}
        data-test-id="product-tile-link"
        to={productUrl ?? ""}
      >
        {children}
      </ProductLink>
    </div>
  );
};

const ProductLink = styled(Link)`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;
